module.exports = __webpack_public_path__ + "static/time-f5073484085d057547e868e6d1ce7518.jpg";